<div class="container-p">
  <div class="container" >
    <div class="d-flex justify-content-center flex-column align-items-center">
      <div style="max-width: 1400px;" class="footer-ctn d-flex" *ngIf="enableContact">
        <div class="footer-left">
          <div class="d-flex justify-content-around">
            <!-- <app-dn-region-selector></app-dn-region-selector> -->
            <app-dn-footer-menu class="d-block" *ngIf="partnerList.length > 0"
              [menuType]="'partner'" [partnerList]="partnerList"
              style="margin-bottom: 60px; min-width: 100px; max-width: 330px;">
            </app-dn-footer-menu>
            <app-dn-footer-menu class="d-block" [menuType]="'about-us'" style="margin-bottom: 60px; width: 150px;"></app-dn-footer-menu>
            <app-dn-footer-menu class="d-block" [menuType]="'web-service'" style="margin-bottom: 60px; width: 205px;"></app-dn-footer-menu>
          </div>
          <!-- <app-dn-copyright></app-dn-copyright> -->
        </div>
        <div class="footer-right d-flex justify-content-end">
          <app-contact-info class="h-100 contact-info-box" [showTitle]="false" [showTime]="false" [onlyIcon]="true" [onlyImg]="true"></app-contact-info>
          <div class="downloads h-100">
            <div class="download-box">
              <a href="/app-download" target="_blank">
                <img class="mb-2 d-block" width="56px" height="56px" src="{{'./assets/images/footer/android.png' | absUrl}}" alt="安卓客户端" loading="lazy">
                <div class="dl-title">安卓客户端</div>
              </a>
            </div>
            <div class="download-box">
              <a href="/app-download" target="_blank">
                <img class="mb-2 d-block" width="56px" height="56px" src="{{'./assets/images/footer/windows.png' | absUrl}}" alt="PC客户端" loading="lazy">
                <div class="dl-title">PC客户端</div>
              </a>
            </div>
            <div class="download-box">
              <a href="/app-download" target="_blank">
                <img class="mb-2 d-block" width="56px" height="56px" src="{{'./assets/images/footer/tv.png' | absUrl}}" alt="电视客户端" loading="lazy">
                <div class="dl-title">电视客户端</div>
              </a>
            </div>
          </div>
        </div>
        <!-- <div class="footer-copyright">Copyright 2010-2020 {{host}} Allrights Reserved.</div> -->
      </div>
      <div class="d-flex">
        <app-dn-region-selector></app-dn-region-selector>
        <app-dn-copyright></app-dn-copyright>
      </div>
    </div>
  </div>
</div>
